/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root.js'
import { Route as LoginRouteImport } from './routes/login.js'
import { Route as LayoutRouteImport } from './routes/_layout.js'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index.js'
import { Route as LayoutMyClassesRouteImport } from './routes/_layout/my-classes.js'
import { Route as Layout404RouteImport } from './routes/_layout/404.js'
import { Route as Layout403RouteImport } from './routes/_layout/403.js'
import { Route as LayoutUsersIndexRouteImport } from './routes/_layout/users/index.js'
import { Route as LayoutTeachersIndexRouteImport } from './routes/_layout/teachers/index.js'
import { Route as LayoutTeachersFeedbackIndexRouteImport } from './routes/_layout/teachers-feedback/index.js'
import { Route as LayoutStudentsIndexRouteImport } from './routes/_layout/students/index.js'
import { Route as LayoutStudentGroupsIndexRouteImport } from './routes/_layout/student-groups/index.js'
import { Route as LayoutSessionsIndexRouteImport } from './routes/_layout/sessions/index.js'
import { Route as LayoutSchoolStudentsIndexRouteImport } from './routes/_layout/school-students/index.js'
import { Route as LayoutSchedulingIndexRouteImport } from './routes/_layout/scheduling/index.js'
import { Route as LayoutProfileIndexRouteImport } from './routes/_layout/profile/index.js'
import { Route as LayoutPaymentsIndexRouteImport } from './routes/_layout/payments/index.js'
import { Route as LayoutOrgsIndexRouteImport } from './routes/_layout/orgs/index.js'
import { Route as LayoutMyStudentGroupsIndexRouteImport } from './routes/_layout/my-student-groups/index.js'
import { Route as LayoutMyClassesIndexRouteImport } from './routes/_layout/my-classes/index.js'
import { Route as LayoutMyAvailabilityIndexRouteImport } from './routes/_layout/my-availability/index.js'
import { Route as LayoutLessonsIndexRouteImport } from './routes/_layout/lessons/index.js'
import { Route as LayoutHandoutsAndFeedbackIndexRouteImport } from './routes/_layout/handouts-and-feedback/index.js'
import { Route as LayoutHandbookIndexRouteImport } from './routes/_layout/handbook/index.js'
import { Route as LayoutGettingReadyToTeachIndexRouteImport } from './routes/_layout/getting-ready-to-teach/index.js'
import { Route as LayoutBooksIndexRouteImport } from './routes/_layout/books/index.js'
import { Route as LayoutAccountIndexRouteImport } from './routes/_layout/account/index.js'
import { Route as LayoutUsersUserIdRouteImport } from './routes/_layout/users/$userId.js'
import { Route as LayoutTeachersFeedbackFeedbackIdRouteImport } from './routes/_layout/teachers-feedback/$feedbackId.js'
import { Route as LayoutSessionsSessionIdRouteImport } from './routes/_layout/sessions/$sessionId.js'
import { Route as LayoutPaymentsGuidelineRouteImport } from './routes/_layout/payments/guideline.js'
import { Route as LayoutMyClassesUpcomingRouteImport } from './routes/_layout/my-classes/upcoming.js'
import { Route as LayoutMyClassesPastRouteImport } from './routes/_layout/my-classes/past.js'
import { Route as LayoutMyClassesCalendarRouteImport } from './routes/_layout/my-classes/calendar.js'
import { Route as LayoutLessonsLessonIdRouteImport } from './routes/_layout/lessons/$lessonId.js'
import { Route as LayoutTeachersTqReviewIndexRouteImport } from './routes/_layout/teachers/tq-review/index.js'
import { Route as LayoutTeachersTeacherPayIndexRouteImport } from './routes/_layout/teachers/teacher-pay/index.js'
import { Route as LayoutTeachersOnboardingIndexRouteImport } from './routes/_layout/teachers/onboarding/index.js'
import { Route as LayoutTeachersMissingZoomLicenseIndexRouteImport } from './routes/_layout/teachers/missing-zoom-license/index.js'
import { Route as LayoutTeachersMissingGoogleMeetIndexRouteImport } from './routes/_layout/teachers/missing-google-meet/index.js'
import { Route as LayoutTeachersGoogleMeetTqReviewIndexRouteImport } from './routes/_layout/teachers/google-meet-tq-review/index.js'
import { Route as LayoutTeachersAvailabilityOverviewIndexRouteImport } from './routes/_layout/teachers/availability-overview/index.js'
import { Route as LayoutTeachersAvailabilitiesIndexRouteImport } from './routes/_layout/teachers/availabilities/index.js'
import { Route as LayoutTeachersAttendanceIndexRouteImport } from './routes/_layout/teachers/attendance/index.js'
import { Route as LayoutTeachersAnnouncementIndexRouteImport } from './routes/_layout/teachers/announcement/index.js'
import { Route as LayoutTeachersTeacherIdIndexRouteImport } from './routes/_layout/teachers/$teacherId/index.js'
import { Route as LayoutStudentsNoFutureSessionsIndexRouteImport } from './routes/_layout/students/no-future-sessions/index.js'
import { Route as LayoutStudentsMultipleScheduleIndexRouteImport } from './routes/_layout/students/multiple-schedule/index.js'
import { Route as LayoutStudentsMakeupDiagnosticIndexRouteImport } from './routes/_layout/students/makeup-diagnostic/index.js'
import { Route as LayoutStudentsLearningIssueIndexRouteImport } from './routes/_layout/students/learning-issue/index.js'
import { Route as LayoutStudentsGlaIndexRouteImport } from './routes/_layout/students/gla/index.js'
import { Route as LayoutStudentsDroppedIndexRouteImport } from './routes/_layout/students/dropped/index.js'
import { Route as LayoutStudentsStudentIdIndexRouteImport } from './routes/_layout/students/$studentId/index.js'
import { Route as LayoutStudentGroupsPendingReassignmentIndexRouteImport } from './routes/_layout/student-groups/pending-reassignment/index.js'
import { Route as LayoutSessionsSubSessionsIndexRouteImport } from './routes/_layout/sessions/sub-sessions/index.js'
import { Route as LayoutSessionsSessionFeedbacksIndexRouteImport } from './routes/_layout/sessions/session-feedbacks/index.js'
import { Route as LayoutSessionsPastIndexRouteImport } from './routes/_layout/sessions/past/index.js'
import { Route as LayoutSessionsOverlappingIndexRouteImport } from './routes/_layout/sessions/overlapping/index.js'
import { Route as LayoutSessionsFutureIndexRouteImport } from './routes/_layout/sessions/future/index.js'
import { Route as LayoutSchedulingSchedulesIndexRouteImport } from './routes/_layout/scheduling/schedules/index.js'
import { Route as LayoutOrgsSchoolsIndexRouteImport } from './routes/_layout/orgs/schools/index.js'
import { Route as LayoutOrgsOrgIdIndexRouteImport } from './routes/_layout/orgs/$orgId/index.js'
import { Route as LayoutLessonsLearningPathsIndexRouteImport } from './routes/_layout/lessons/learning-paths/index.js'
import { Route as LayoutLessonsAssessmentsIndexRouteImport } from './routes/_layout/lessons/assessments/index.js'
import { Route as LayoutLessonsAssessmentContentsIndexRouteImport } from './routes/_layout/lessons/assessment-contents/index.js'
import { Route as LayoutBooksPartIndexRouteImport } from './routes/_layout/books/part/index.js'
import { Route as LayoutTeachersTeacherIdWeeklyTeachingHoursRouteImport } from './routes/_layout/teachers/$teacherId/weekly-teaching-hours.js'
import { Route as LayoutTeachersTeacherIdScheduleRouteImport } from './routes/_layout/teachers/$teacherId/schedule.js'
import { Route as LayoutTeachersTeacherIdReviewNotesRouteImport } from './routes/_layout/teachers/$teacherId/review-notes.js'
import { Route as LayoutTeachersTeacherIdFeedbacksRouteImport } from './routes/_layout/teachers/$teacherId/feedbacks.js'
import { Route as LayoutSessionsSessionFeedbacksFeedbackIdRouteImport } from './routes/_layout/sessions/session-feedbacks/$feedbackId.js'
import { Route as LayoutOrgsOrgIdSettingsRouteImport } from './routes/_layout/orgs/$orgId/settings.js'
import { Route as LayoutLessonsAssessmentContentsAssessmentContentIdRouteImport } from './routes/_layout/lessons/assessment-contents/$assessmentContentId.js'
import { Route as LayoutBooksPartPartIdRouteImport } from './routes/_layout/books/part/$partId.js'
import { Route as LayoutTeachersTeacherIdPaymentsIndexRouteImport } from './routes/_layout/teachers/$teacherId/payments/index.js'
import { Route as LayoutTeachersTeacherIdPastSessionsIndexRouteImport } from './routes/_layout/teachers/$teacherId/past-sessions/index.js'
import { Route as LayoutTeachersTeacherIdFutureSessionsIndexRouteImport } from './routes/_layout/teachers/$teacherId/future-sessions/index.js'
import { Route as LayoutStudentsStudentIdPastStudentFeedbacksIndexRouteImport } from './routes/_layout/students/$studentId/past-student-feedbacks/index.js'
import { Route as LayoutStudentsStudentIdFutureSessionsIndexRouteImport } from './routes/_layout/students/$studentId/future-sessions/index.js'
import { Route as LayoutPaymentsTeachingPayCycleIdIndexRouteImport } from './routes/_layout/payments/teaching/$payCycleId/index.js'
import { Route as LayoutOrgsSchoolsReportsIndexRouteImport } from './routes/_layout/orgs/schools/reports/index.js'
import { Route as LayoutOrgsSchoolsSchoolIdIndexRouteImport } from './routes/_layout/orgs/schools/$schoolId/index.js'
import { Route as LayoutOrgsSchoolsSchoolIdStudentsRouteImport } from './routes/_layout/orgs/schools/$schoolId/students.js'
import { Route as LayoutOrgsSchoolsSchoolIdSettingsRouteImport } from './routes/_layout/orgs/schools/$schoolId/settings.js'
import { Route as LayoutOrgsSchoolsSchoolIdSessionsRouteImport } from './routes/_layout/orgs/schools/$schoolId/sessions.js'
import { Route as LayoutOrgsSchoolsSchoolIdSessionAttendanceRouteImport } from './routes/_layout/orgs/schools/$schoolId/session-attendance.js'
import { Route as LayoutOrgsSchoolsSchoolIdSchedulesRouteImport } from './routes/_layout/orgs/schools/$schoolId/schedules.js'
import { Route as LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRouteImport } from './routes/_layout/orgs/schools/$schoolId/one-time-classes/index.js'
import { Route as LayoutOrgsSchoolsSchoolIdClassesIndexRouteImport } from './routes/_layout/orgs/schools/$schoolId/classes/index.js'
import { Route as LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRouteImport } from './routes/_layout/orgs/schools/$schoolId/one-time-classes/$classId.js'
import { Route as LayoutOrgsSchoolsSchoolIdClassesClassIdRouteImport } from './routes/_layout/orgs/schools/$schoolId/classes/$classId.js'
import { Route as LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRouteImport } from './routes/_layout/teachers/$teacherId/payments/teaching/$payCycleId/index.js'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutMyClassesRoute = LayoutMyClassesRouteImport.update({
  id: '/my-classes',
  path: '/my-classes',
  getParentRoute: () => LayoutRoute,
} as any)
const Layout404Route = Layout404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => LayoutRoute,
} as any)
const Layout403Route = Layout403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutUsersIndexRoute = LayoutUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTeachersIndexRoute = LayoutTeachersIndexRouteImport.update({
  id: '/teachers/',
  path: '/teachers/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTeachersFeedbackIndexRoute =
  LayoutTeachersFeedbackIndexRouteImport.update({
    id: '/teachers-feedback/',
    path: '/teachers-feedback/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStudentsIndexRoute = LayoutStudentsIndexRouteImport.update({
  id: '/students/',
  path: '/students/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStudentGroupsIndexRoute =
  LayoutStudentGroupsIndexRouteImport.update({
    id: '/student-groups/',
    path: '/student-groups/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSessionsIndexRoute = LayoutSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSchoolStudentsIndexRoute =
  LayoutSchoolStudentsIndexRouteImport.update({
    id: '/school-students/',
    path: '/school-students/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSchedulingIndexRoute = LayoutSchedulingIndexRouteImport.update({
  id: '/scheduling/',
  path: '/scheduling/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutProfileIndexRoute = LayoutProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPaymentsIndexRoute = LayoutPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutOrgsIndexRoute = LayoutOrgsIndexRouteImport.update({
  id: '/orgs/',
  path: '/orgs/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutMyStudentGroupsIndexRoute =
  LayoutMyStudentGroupsIndexRouteImport.update({
    id: '/my-student-groups/',
    path: '/my-student-groups/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutMyClassesIndexRoute = LayoutMyClassesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutMyClassesRoute,
} as any)
const LayoutMyAvailabilityIndexRoute =
  LayoutMyAvailabilityIndexRouteImport.update({
    id: '/my-availability/',
    path: '/my-availability/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutLessonsIndexRoute = LayoutLessonsIndexRouteImport.update({
  id: '/lessons/',
  path: '/lessons/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutHandoutsAndFeedbackIndexRoute =
  LayoutHandoutsAndFeedbackIndexRouteImport.update({
    id: '/handouts-and-feedback/',
    path: '/handouts-and-feedback/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutHandbookIndexRoute = LayoutHandbookIndexRouteImport.update({
  id: '/handbook/',
  path: '/handbook/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutGettingReadyToTeachIndexRoute =
  LayoutGettingReadyToTeachIndexRouteImport.update({
    id: '/getting-ready-to-teach/',
    path: '/getting-ready-to-teach/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutBooksIndexRoute = LayoutBooksIndexRouteImport.update({
  id: '/books/',
  path: '/books/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAccountIndexRoute = LayoutAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutUsersUserIdRoute = LayoutUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTeachersFeedbackFeedbackIdRoute =
  LayoutTeachersFeedbackFeedbackIdRouteImport.update({
    id: '/teachers-feedback/$feedbackId',
    path: '/teachers-feedback/$feedbackId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSessionsSessionIdRoute = LayoutSessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPaymentsGuidelineRoute = LayoutPaymentsGuidelineRouteImport.update({
  id: '/payments/guideline',
  path: '/payments/guideline',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutMyClassesUpcomingRoute = LayoutMyClassesUpcomingRouteImport.update({
  id: '/upcoming',
  path: '/upcoming',
  getParentRoute: () => LayoutMyClassesRoute,
} as any)
const LayoutMyClassesPastRoute = LayoutMyClassesPastRouteImport.update({
  id: '/past',
  path: '/past',
  getParentRoute: () => LayoutMyClassesRoute,
} as any)
const LayoutMyClassesCalendarRoute = LayoutMyClassesCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => LayoutMyClassesRoute,
} as any)
const LayoutLessonsLessonIdRoute = LayoutLessonsLessonIdRouteImport.update({
  id: '/lessons/$lessonId',
  path: '/lessons/$lessonId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTeachersTqReviewIndexRoute =
  LayoutTeachersTqReviewIndexRouteImport.update({
    id: '/teachers/tq-review/',
    path: '/teachers/tq-review/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersTeacherPayIndexRoute =
  LayoutTeachersTeacherPayIndexRouteImport.update({
    id: '/teachers/teacher-pay/',
    path: '/teachers/teacher-pay/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersOnboardingIndexRoute =
  LayoutTeachersOnboardingIndexRouteImport.update({
    id: '/teachers/onboarding/',
    path: '/teachers/onboarding/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersMissingZoomLicenseIndexRoute =
  LayoutTeachersMissingZoomLicenseIndexRouteImport.update({
    id: '/teachers/missing-zoom-license/',
    path: '/teachers/missing-zoom-license/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersMissingGoogleMeetIndexRoute =
  LayoutTeachersMissingGoogleMeetIndexRouteImport.update({
    id: '/teachers/missing-google-meet/',
    path: '/teachers/missing-google-meet/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersGoogleMeetTqReviewIndexRoute =
  LayoutTeachersGoogleMeetTqReviewIndexRouteImport.update({
    id: '/teachers/google-meet-tq-review/',
    path: '/teachers/google-meet-tq-review/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersAvailabilityOverviewIndexRoute =
  LayoutTeachersAvailabilityOverviewIndexRouteImport.update({
    id: '/teachers/availability-overview/',
    path: '/teachers/availability-overview/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersAvailabilitiesIndexRoute =
  LayoutTeachersAvailabilitiesIndexRouteImport.update({
    id: '/teachers/availabilities/',
    path: '/teachers/availabilities/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersAttendanceIndexRoute =
  LayoutTeachersAttendanceIndexRouteImport.update({
    id: '/teachers/attendance/',
    path: '/teachers/attendance/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersAnnouncementIndexRoute =
  LayoutTeachersAnnouncementIndexRouteImport.update({
    id: '/teachers/announcement/',
    path: '/teachers/announcement/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersTeacherIdIndexRoute =
  LayoutTeachersTeacherIdIndexRouteImport.update({
    id: '/teachers/$teacherId/',
    path: '/teachers/$teacherId/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStudentsNoFutureSessionsIndexRoute =
  LayoutStudentsNoFutureSessionsIndexRouteImport.update({
    id: '/students/no-future-sessions/',
    path: '/students/no-future-sessions/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStudentsMultipleScheduleIndexRoute =
  LayoutStudentsMultipleScheduleIndexRouteImport.update({
    id: '/students/multiple-schedule/',
    path: '/students/multiple-schedule/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStudentsMakeupDiagnosticIndexRoute =
  LayoutStudentsMakeupDiagnosticIndexRouteImport.update({
    id: '/students/makeup-diagnostic/',
    path: '/students/makeup-diagnostic/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStudentsLearningIssueIndexRoute =
  LayoutStudentsLearningIssueIndexRouteImport.update({
    id: '/students/learning-issue/',
    path: '/students/learning-issue/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStudentsGlaIndexRoute = LayoutStudentsGlaIndexRouteImport.update({
  id: '/students/gla/',
  path: '/students/gla/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStudentsDroppedIndexRoute =
  LayoutStudentsDroppedIndexRouteImport.update({
    id: '/students/dropped/',
    path: '/students/dropped/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStudentsStudentIdIndexRoute =
  LayoutStudentsStudentIdIndexRouteImport.update({
    id: '/students/$studentId/',
    path: '/students/$studentId/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStudentGroupsPendingReassignmentIndexRoute =
  LayoutStudentGroupsPendingReassignmentIndexRouteImport.update({
    id: '/student-groups/pending-reassignment/',
    path: '/student-groups/pending-reassignment/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSessionsSubSessionsIndexRoute =
  LayoutSessionsSubSessionsIndexRouteImport.update({
    id: '/sessions/sub-sessions/',
    path: '/sessions/sub-sessions/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSessionsSessionFeedbacksIndexRoute =
  LayoutSessionsSessionFeedbacksIndexRouteImport.update({
    id: '/sessions/session-feedbacks/',
    path: '/sessions/session-feedbacks/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSessionsPastIndexRoute = LayoutSessionsPastIndexRouteImport.update({
  id: '/sessions/past/',
  path: '/sessions/past/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSessionsOverlappingIndexRoute =
  LayoutSessionsOverlappingIndexRouteImport.update({
    id: '/sessions/overlapping/',
    path: '/sessions/overlapping/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSessionsFutureIndexRoute =
  LayoutSessionsFutureIndexRouteImport.update({
    id: '/sessions/future/',
    path: '/sessions/future/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSchedulingSchedulesIndexRoute =
  LayoutSchedulingSchedulesIndexRouteImport.update({
    id: '/scheduling/schedules/',
    path: '/scheduling/schedules/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsIndexRoute = LayoutOrgsSchoolsIndexRouteImport.update({
  id: '/orgs/schools/',
  path: '/orgs/schools/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutOrgsOrgIdIndexRoute = LayoutOrgsOrgIdIndexRouteImport.update({
  id: '/orgs/$orgId/',
  path: '/orgs/$orgId/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutLessonsLearningPathsIndexRoute =
  LayoutLessonsLearningPathsIndexRouteImport.update({
    id: '/lessons/learning-paths/',
    path: '/lessons/learning-paths/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutLessonsAssessmentsIndexRoute =
  LayoutLessonsAssessmentsIndexRouteImport.update({
    id: '/lessons/assessments/',
    path: '/lessons/assessments/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutLessonsAssessmentContentsIndexRoute =
  LayoutLessonsAssessmentContentsIndexRouteImport.update({
    id: '/lessons/assessment-contents/',
    path: '/lessons/assessment-contents/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutBooksPartIndexRoute = LayoutBooksPartIndexRouteImport.update({
  id: '/books/part/',
  path: '/books/part/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTeachersTeacherIdWeeklyTeachingHoursRoute =
  LayoutTeachersTeacherIdWeeklyTeachingHoursRouteImport.update({
    id: '/teachers/$teacherId/weekly-teaching-hours',
    path: '/teachers/$teacherId/weekly-teaching-hours',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersTeacherIdScheduleRoute =
  LayoutTeachersTeacherIdScheduleRouteImport.update({
    id: '/teachers/$teacherId/schedule',
    path: '/teachers/$teacherId/schedule',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersTeacherIdReviewNotesRoute =
  LayoutTeachersTeacherIdReviewNotesRouteImport.update({
    id: '/teachers/$teacherId/review-notes',
    path: '/teachers/$teacherId/review-notes',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersTeacherIdFeedbacksRoute =
  LayoutTeachersTeacherIdFeedbacksRouteImport.update({
    id: '/teachers/$teacherId/feedbacks',
    path: '/teachers/$teacherId/feedbacks',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSessionsSessionFeedbacksFeedbackIdRoute =
  LayoutSessionsSessionFeedbacksFeedbackIdRouteImport.update({
    id: '/sessions/session-feedbacks/$feedbackId',
    path: '/sessions/session-feedbacks/$feedbackId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsOrgIdSettingsRoute = LayoutOrgsOrgIdSettingsRouteImport.update({
  id: '/orgs/$orgId/settings',
  path: '/orgs/$orgId/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutLessonsAssessmentContentsAssessmentContentIdRoute =
  LayoutLessonsAssessmentContentsAssessmentContentIdRouteImport.update({
    id: '/lessons/assessment-contents/$assessmentContentId',
    path: '/lessons/assessment-contents/$assessmentContentId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutBooksPartPartIdRoute = LayoutBooksPartPartIdRouteImport.update({
  id: '/books/part/$partId',
  path: '/books/part/$partId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTeachersTeacherIdPaymentsIndexRoute =
  LayoutTeachersTeacherIdPaymentsIndexRouteImport.update({
    id: '/teachers/$teacherId/payments/',
    path: '/teachers/$teacherId/payments/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersTeacherIdPastSessionsIndexRoute =
  LayoutTeachersTeacherIdPastSessionsIndexRouteImport.update({
    id: '/teachers/$teacherId/past-sessions/',
    path: '/teachers/$teacherId/past-sessions/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersTeacherIdFutureSessionsIndexRoute =
  LayoutTeachersTeacherIdFutureSessionsIndexRouteImport.update({
    id: '/teachers/$teacherId/future-sessions/',
    path: '/teachers/$teacherId/future-sessions/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStudentsStudentIdPastStudentFeedbacksIndexRoute =
  LayoutStudentsStudentIdPastStudentFeedbacksIndexRouteImport.update({
    id: '/students/$studentId/past-student-feedbacks/',
    path: '/students/$studentId/past-student-feedbacks/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutStudentsStudentIdFutureSessionsIndexRoute =
  LayoutStudentsStudentIdFutureSessionsIndexRouteImport.update({
    id: '/students/$studentId/future-sessions/',
    path: '/students/$studentId/future-sessions/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutPaymentsTeachingPayCycleIdIndexRoute =
  LayoutPaymentsTeachingPayCycleIdIndexRouteImport.update({
    id: '/payments/teaching/$payCycleId/',
    path: '/payments/teaching/$payCycleId/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsReportsIndexRoute =
  LayoutOrgsSchoolsReportsIndexRouteImport.update({
    id: '/orgs/schools/reports/',
    path: '/orgs/schools/reports/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsSchoolIdIndexRoute =
  LayoutOrgsSchoolsSchoolIdIndexRouteImport.update({
    id: '/orgs/schools/$schoolId/',
    path: '/orgs/schools/$schoolId/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsSchoolIdStudentsRoute =
  LayoutOrgsSchoolsSchoolIdStudentsRouteImport.update({
    id: '/orgs/schools/$schoolId/students',
    path: '/orgs/schools/$schoolId/students',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsSchoolIdSettingsRoute =
  LayoutOrgsSchoolsSchoolIdSettingsRouteImport.update({
    id: '/orgs/schools/$schoolId/settings',
    path: '/orgs/schools/$schoolId/settings',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsSchoolIdSessionsRoute =
  LayoutOrgsSchoolsSchoolIdSessionsRouteImport.update({
    id: '/orgs/schools/$schoolId/sessions',
    path: '/orgs/schools/$schoolId/sessions',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsSchoolIdSessionAttendanceRoute =
  LayoutOrgsSchoolsSchoolIdSessionAttendanceRouteImport.update({
    id: '/orgs/schools/$schoolId/session-attendance',
    path: '/orgs/schools/$schoolId/session-attendance',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsSchoolIdSchedulesRoute =
  LayoutOrgsSchoolsSchoolIdSchedulesRouteImport.update({
    id: '/orgs/schools/$schoolId/schedules',
    path: '/orgs/schools/$schoolId/schedules',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRoute =
  LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRouteImport.update({
    id: '/orgs/schools/$schoolId/one-time-classes/',
    path: '/orgs/schools/$schoolId/one-time-classes/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsSchoolIdClassesIndexRoute =
  LayoutOrgsSchoolsSchoolIdClassesIndexRouteImport.update({
    id: '/orgs/schools/$schoolId/classes/',
    path: '/orgs/schools/$schoolId/classes/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRoute =
  LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRouteImport.update({
    id: '/orgs/schools/$schoolId/one-time-classes/$classId',
    path: '/orgs/schools/$schoolId/one-time-classes/$classId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutOrgsSchoolsSchoolIdClassesClassIdRoute =
  LayoutOrgsSchoolsSchoolIdClassesClassIdRouteImport.update({
    id: '/orgs/schools/$schoolId/classes/$classId',
    path: '/orgs/schools/$schoolId/classes/$classId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRoute =
  LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRouteImport.update({
    id: '/teachers/$teacherId/payments/teaching/$payCycleId/',
    path: '/teachers/$teacherId/payments/teaching/$payCycleId/',
    getParentRoute: () => LayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/login': typeof LoginRoute
  '/403': typeof Layout403Route
  '/404': typeof Layout404Route
  '/my-classes': typeof LayoutMyClassesRouteWithChildren
  '/lessons/$lessonId': typeof LayoutLessonsLessonIdRoute
  '/my-classes/calendar': typeof LayoutMyClassesCalendarRoute
  '/my-classes/past': typeof LayoutMyClassesPastRoute
  '/my-classes/upcoming': typeof LayoutMyClassesUpcomingRoute
  '/payments/guideline': typeof LayoutPaymentsGuidelineRoute
  '/sessions/$sessionId': typeof LayoutSessionsSessionIdRoute
  '/teachers-feedback/$feedbackId': typeof LayoutTeachersFeedbackFeedbackIdRoute
  '/users/$userId': typeof LayoutUsersUserIdRoute
  '/account/': typeof LayoutAccountIndexRoute
  '/books/': typeof LayoutBooksIndexRoute
  '/getting-ready-to-teach/': typeof LayoutGettingReadyToTeachIndexRoute
  '/handbook/': typeof LayoutHandbookIndexRoute
  '/handouts-and-feedback/': typeof LayoutHandoutsAndFeedbackIndexRoute
  '/lessons/': typeof LayoutLessonsIndexRoute
  '/my-availability/': typeof LayoutMyAvailabilityIndexRoute
  '/my-classes/': typeof LayoutMyClassesIndexRoute
  '/my-student-groups/': typeof LayoutMyStudentGroupsIndexRoute
  '/orgs/': typeof LayoutOrgsIndexRoute
  '/payments/': typeof LayoutPaymentsIndexRoute
  '/profile/': typeof LayoutProfileIndexRoute
  '/scheduling/': typeof LayoutSchedulingIndexRoute
  '/school-students/': typeof LayoutSchoolStudentsIndexRoute
  '/sessions/': typeof LayoutSessionsIndexRoute
  '/student-groups/': typeof LayoutStudentGroupsIndexRoute
  '/students/': typeof LayoutStudentsIndexRoute
  '/teachers-feedback/': typeof LayoutTeachersFeedbackIndexRoute
  '/teachers/': typeof LayoutTeachersIndexRoute
  '/users/': typeof LayoutUsersIndexRoute
  '/books/part/$partId': typeof LayoutBooksPartPartIdRoute
  '/lessons/assessment-contents/$assessmentContentId': typeof LayoutLessonsAssessmentContentsAssessmentContentIdRoute
  '/orgs/$orgId/settings': typeof LayoutOrgsOrgIdSettingsRoute
  '/sessions/session-feedbacks/$feedbackId': typeof LayoutSessionsSessionFeedbacksFeedbackIdRoute
  '/teachers/$teacherId/feedbacks': typeof LayoutTeachersTeacherIdFeedbacksRoute
  '/teachers/$teacherId/review-notes': typeof LayoutTeachersTeacherIdReviewNotesRoute
  '/teachers/$teacherId/schedule': typeof LayoutTeachersTeacherIdScheduleRoute
  '/teachers/$teacherId/weekly-teaching-hours': typeof LayoutTeachersTeacherIdWeeklyTeachingHoursRoute
  '/books/part/': typeof LayoutBooksPartIndexRoute
  '/lessons/assessment-contents/': typeof LayoutLessonsAssessmentContentsIndexRoute
  '/lessons/assessments/': typeof LayoutLessonsAssessmentsIndexRoute
  '/lessons/learning-paths/': typeof LayoutLessonsLearningPathsIndexRoute
  '/orgs/$orgId/': typeof LayoutOrgsOrgIdIndexRoute
  '/orgs/schools/': typeof LayoutOrgsSchoolsIndexRoute
  '/scheduling/schedules/': typeof LayoutSchedulingSchedulesIndexRoute
  '/sessions/future/': typeof LayoutSessionsFutureIndexRoute
  '/sessions/overlapping/': typeof LayoutSessionsOverlappingIndexRoute
  '/sessions/past/': typeof LayoutSessionsPastIndexRoute
  '/sessions/session-feedbacks/': typeof LayoutSessionsSessionFeedbacksIndexRoute
  '/sessions/sub-sessions/': typeof LayoutSessionsSubSessionsIndexRoute
  '/student-groups/pending-reassignment/': typeof LayoutStudentGroupsPendingReassignmentIndexRoute
  '/students/$studentId/': typeof LayoutStudentsStudentIdIndexRoute
  '/students/dropped/': typeof LayoutStudentsDroppedIndexRoute
  '/students/gla/': typeof LayoutStudentsGlaIndexRoute
  '/students/learning-issue/': typeof LayoutStudentsLearningIssueIndexRoute
  '/students/makeup-diagnostic/': typeof LayoutStudentsMakeupDiagnosticIndexRoute
  '/students/multiple-schedule/': typeof LayoutStudentsMultipleScheduleIndexRoute
  '/students/no-future-sessions/': typeof LayoutStudentsNoFutureSessionsIndexRoute
  '/teachers/$teacherId/': typeof LayoutTeachersTeacherIdIndexRoute
  '/teachers/announcement/': typeof LayoutTeachersAnnouncementIndexRoute
  '/teachers/attendance/': typeof LayoutTeachersAttendanceIndexRoute
  '/teachers/availabilities/': typeof LayoutTeachersAvailabilitiesIndexRoute
  '/teachers/availability-overview/': typeof LayoutTeachersAvailabilityOverviewIndexRoute
  '/teachers/google-meet-tq-review/': typeof LayoutTeachersGoogleMeetTqReviewIndexRoute
  '/teachers/missing-google-meet/': typeof LayoutTeachersMissingGoogleMeetIndexRoute
  '/teachers/missing-zoom-license/': typeof LayoutTeachersMissingZoomLicenseIndexRoute
  '/teachers/onboarding/': typeof LayoutTeachersOnboardingIndexRoute
  '/teachers/teacher-pay/': typeof LayoutTeachersTeacherPayIndexRoute
  '/teachers/tq-review/': typeof LayoutTeachersTqReviewIndexRoute
  '/orgs/schools/$schoolId/schedules': typeof LayoutOrgsSchoolsSchoolIdSchedulesRoute
  '/orgs/schools/$schoolId/session-attendance': typeof LayoutOrgsSchoolsSchoolIdSessionAttendanceRoute
  '/orgs/schools/$schoolId/sessions': typeof LayoutOrgsSchoolsSchoolIdSessionsRoute
  '/orgs/schools/$schoolId/settings': typeof LayoutOrgsSchoolsSchoolIdSettingsRoute
  '/orgs/schools/$schoolId/students': typeof LayoutOrgsSchoolsSchoolIdStudentsRoute
  '/orgs/schools/$schoolId/': typeof LayoutOrgsSchoolsSchoolIdIndexRoute
  '/orgs/schools/reports/': typeof LayoutOrgsSchoolsReportsIndexRoute
  '/payments/teaching/$payCycleId/': typeof LayoutPaymentsTeachingPayCycleIdIndexRoute
  '/students/$studentId/future-sessions/': typeof LayoutStudentsStudentIdFutureSessionsIndexRoute
  '/students/$studentId/past-student-feedbacks/': typeof LayoutStudentsStudentIdPastStudentFeedbacksIndexRoute
  '/teachers/$teacherId/future-sessions/': typeof LayoutTeachersTeacherIdFutureSessionsIndexRoute
  '/teachers/$teacherId/past-sessions/': typeof LayoutTeachersTeacherIdPastSessionsIndexRoute
  '/teachers/$teacherId/payments/': typeof LayoutTeachersTeacherIdPaymentsIndexRoute
  '/orgs/schools/$schoolId/classes/$classId': typeof LayoutOrgsSchoolsSchoolIdClassesClassIdRoute
  '/orgs/schools/$schoolId/one-time-classes/$classId': typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRoute
  '/orgs/schools/$schoolId/classes/': typeof LayoutOrgsSchoolsSchoolIdClassesIndexRoute
  '/orgs/schools/$schoolId/one-time-classes/': typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRoute
  '/teachers/$teacherId/payments/teaching/$payCycleId/': typeof LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/403': typeof Layout403Route
  '/404': typeof Layout404Route
  '/': typeof LayoutIndexRoute
  '/lessons/$lessonId': typeof LayoutLessonsLessonIdRoute
  '/my-classes/calendar': typeof LayoutMyClassesCalendarRoute
  '/my-classes/past': typeof LayoutMyClassesPastRoute
  '/my-classes/upcoming': typeof LayoutMyClassesUpcomingRoute
  '/payments/guideline': typeof LayoutPaymentsGuidelineRoute
  '/sessions/$sessionId': typeof LayoutSessionsSessionIdRoute
  '/teachers-feedback/$feedbackId': typeof LayoutTeachersFeedbackFeedbackIdRoute
  '/users/$userId': typeof LayoutUsersUserIdRoute
  '/account': typeof LayoutAccountIndexRoute
  '/books': typeof LayoutBooksIndexRoute
  '/getting-ready-to-teach': typeof LayoutGettingReadyToTeachIndexRoute
  '/handbook': typeof LayoutHandbookIndexRoute
  '/handouts-and-feedback': typeof LayoutHandoutsAndFeedbackIndexRoute
  '/lessons': typeof LayoutLessonsIndexRoute
  '/my-availability': typeof LayoutMyAvailabilityIndexRoute
  '/my-classes': typeof LayoutMyClassesIndexRoute
  '/my-student-groups': typeof LayoutMyStudentGroupsIndexRoute
  '/orgs': typeof LayoutOrgsIndexRoute
  '/payments': typeof LayoutPaymentsIndexRoute
  '/profile': typeof LayoutProfileIndexRoute
  '/scheduling': typeof LayoutSchedulingIndexRoute
  '/school-students': typeof LayoutSchoolStudentsIndexRoute
  '/sessions': typeof LayoutSessionsIndexRoute
  '/student-groups': typeof LayoutStudentGroupsIndexRoute
  '/students': typeof LayoutStudentsIndexRoute
  '/teachers-feedback': typeof LayoutTeachersFeedbackIndexRoute
  '/teachers': typeof LayoutTeachersIndexRoute
  '/users': typeof LayoutUsersIndexRoute
  '/books/part/$partId': typeof LayoutBooksPartPartIdRoute
  '/lessons/assessment-contents/$assessmentContentId': typeof LayoutLessonsAssessmentContentsAssessmentContentIdRoute
  '/orgs/$orgId/settings': typeof LayoutOrgsOrgIdSettingsRoute
  '/sessions/session-feedbacks/$feedbackId': typeof LayoutSessionsSessionFeedbacksFeedbackIdRoute
  '/teachers/$teacherId/feedbacks': typeof LayoutTeachersTeacherIdFeedbacksRoute
  '/teachers/$teacherId/review-notes': typeof LayoutTeachersTeacherIdReviewNotesRoute
  '/teachers/$teacherId/schedule': typeof LayoutTeachersTeacherIdScheduleRoute
  '/teachers/$teacherId/weekly-teaching-hours': typeof LayoutTeachersTeacherIdWeeklyTeachingHoursRoute
  '/books/part': typeof LayoutBooksPartIndexRoute
  '/lessons/assessment-contents': typeof LayoutLessonsAssessmentContentsIndexRoute
  '/lessons/assessments': typeof LayoutLessonsAssessmentsIndexRoute
  '/lessons/learning-paths': typeof LayoutLessonsLearningPathsIndexRoute
  '/orgs/$orgId': typeof LayoutOrgsOrgIdIndexRoute
  '/orgs/schools': typeof LayoutOrgsSchoolsIndexRoute
  '/scheduling/schedules': typeof LayoutSchedulingSchedulesIndexRoute
  '/sessions/future': typeof LayoutSessionsFutureIndexRoute
  '/sessions/overlapping': typeof LayoutSessionsOverlappingIndexRoute
  '/sessions/past': typeof LayoutSessionsPastIndexRoute
  '/sessions/session-feedbacks': typeof LayoutSessionsSessionFeedbacksIndexRoute
  '/sessions/sub-sessions': typeof LayoutSessionsSubSessionsIndexRoute
  '/student-groups/pending-reassignment': typeof LayoutStudentGroupsPendingReassignmentIndexRoute
  '/students/$studentId': typeof LayoutStudentsStudentIdIndexRoute
  '/students/dropped': typeof LayoutStudentsDroppedIndexRoute
  '/students/gla': typeof LayoutStudentsGlaIndexRoute
  '/students/learning-issue': typeof LayoutStudentsLearningIssueIndexRoute
  '/students/makeup-diagnostic': typeof LayoutStudentsMakeupDiagnosticIndexRoute
  '/students/multiple-schedule': typeof LayoutStudentsMultipleScheduleIndexRoute
  '/students/no-future-sessions': typeof LayoutStudentsNoFutureSessionsIndexRoute
  '/teachers/$teacherId': typeof LayoutTeachersTeacherIdIndexRoute
  '/teachers/announcement': typeof LayoutTeachersAnnouncementIndexRoute
  '/teachers/attendance': typeof LayoutTeachersAttendanceIndexRoute
  '/teachers/availabilities': typeof LayoutTeachersAvailabilitiesIndexRoute
  '/teachers/availability-overview': typeof LayoutTeachersAvailabilityOverviewIndexRoute
  '/teachers/google-meet-tq-review': typeof LayoutTeachersGoogleMeetTqReviewIndexRoute
  '/teachers/missing-google-meet': typeof LayoutTeachersMissingGoogleMeetIndexRoute
  '/teachers/missing-zoom-license': typeof LayoutTeachersMissingZoomLicenseIndexRoute
  '/teachers/onboarding': typeof LayoutTeachersOnboardingIndexRoute
  '/teachers/teacher-pay': typeof LayoutTeachersTeacherPayIndexRoute
  '/teachers/tq-review': typeof LayoutTeachersTqReviewIndexRoute
  '/orgs/schools/$schoolId/schedules': typeof LayoutOrgsSchoolsSchoolIdSchedulesRoute
  '/orgs/schools/$schoolId/session-attendance': typeof LayoutOrgsSchoolsSchoolIdSessionAttendanceRoute
  '/orgs/schools/$schoolId/sessions': typeof LayoutOrgsSchoolsSchoolIdSessionsRoute
  '/orgs/schools/$schoolId/settings': typeof LayoutOrgsSchoolsSchoolIdSettingsRoute
  '/orgs/schools/$schoolId/students': typeof LayoutOrgsSchoolsSchoolIdStudentsRoute
  '/orgs/schools/$schoolId': typeof LayoutOrgsSchoolsSchoolIdIndexRoute
  '/orgs/schools/reports': typeof LayoutOrgsSchoolsReportsIndexRoute
  '/payments/teaching/$payCycleId': typeof LayoutPaymentsTeachingPayCycleIdIndexRoute
  '/students/$studentId/future-sessions': typeof LayoutStudentsStudentIdFutureSessionsIndexRoute
  '/students/$studentId/past-student-feedbacks': typeof LayoutStudentsStudentIdPastStudentFeedbacksIndexRoute
  '/teachers/$teacherId/future-sessions': typeof LayoutTeachersTeacherIdFutureSessionsIndexRoute
  '/teachers/$teacherId/past-sessions': typeof LayoutTeachersTeacherIdPastSessionsIndexRoute
  '/teachers/$teacherId/payments': typeof LayoutTeachersTeacherIdPaymentsIndexRoute
  '/orgs/schools/$schoolId/classes/$classId': typeof LayoutOrgsSchoolsSchoolIdClassesClassIdRoute
  '/orgs/schools/$schoolId/one-time-classes/$classId': typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRoute
  '/orgs/schools/$schoolId/classes': typeof LayoutOrgsSchoolsSchoolIdClassesIndexRoute
  '/orgs/schools/$schoolId/one-time-classes': typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRoute
  '/teachers/$teacherId/payments/teaching/$payCycleId': typeof LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/_layout/403': typeof Layout403Route
  '/_layout/404': typeof Layout404Route
  '/_layout/my-classes': typeof LayoutMyClassesRouteWithChildren
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/lessons/$lessonId': typeof LayoutLessonsLessonIdRoute
  '/_layout/my-classes/calendar': typeof LayoutMyClassesCalendarRoute
  '/_layout/my-classes/past': typeof LayoutMyClassesPastRoute
  '/_layout/my-classes/upcoming': typeof LayoutMyClassesUpcomingRoute
  '/_layout/payments/guideline': typeof LayoutPaymentsGuidelineRoute
  '/_layout/sessions/$sessionId': typeof LayoutSessionsSessionIdRoute
  '/_layout/teachers-feedback/$feedbackId': typeof LayoutTeachersFeedbackFeedbackIdRoute
  '/_layout/users/$userId': typeof LayoutUsersUserIdRoute
  '/_layout/account/': typeof LayoutAccountIndexRoute
  '/_layout/books/': typeof LayoutBooksIndexRoute
  '/_layout/getting-ready-to-teach/': typeof LayoutGettingReadyToTeachIndexRoute
  '/_layout/handbook/': typeof LayoutHandbookIndexRoute
  '/_layout/handouts-and-feedback/': typeof LayoutHandoutsAndFeedbackIndexRoute
  '/_layout/lessons/': typeof LayoutLessonsIndexRoute
  '/_layout/my-availability/': typeof LayoutMyAvailabilityIndexRoute
  '/_layout/my-classes/': typeof LayoutMyClassesIndexRoute
  '/_layout/my-student-groups/': typeof LayoutMyStudentGroupsIndexRoute
  '/_layout/orgs/': typeof LayoutOrgsIndexRoute
  '/_layout/payments/': typeof LayoutPaymentsIndexRoute
  '/_layout/profile/': typeof LayoutProfileIndexRoute
  '/_layout/scheduling/': typeof LayoutSchedulingIndexRoute
  '/_layout/school-students/': typeof LayoutSchoolStudentsIndexRoute
  '/_layout/sessions/': typeof LayoutSessionsIndexRoute
  '/_layout/student-groups/': typeof LayoutStudentGroupsIndexRoute
  '/_layout/students/': typeof LayoutStudentsIndexRoute
  '/_layout/teachers-feedback/': typeof LayoutTeachersFeedbackIndexRoute
  '/_layout/teachers/': typeof LayoutTeachersIndexRoute
  '/_layout/users/': typeof LayoutUsersIndexRoute
  '/_layout/books/part/$partId': typeof LayoutBooksPartPartIdRoute
  '/_layout/lessons/assessment-contents/$assessmentContentId': typeof LayoutLessonsAssessmentContentsAssessmentContentIdRoute
  '/_layout/orgs/$orgId/settings': typeof LayoutOrgsOrgIdSettingsRoute
  '/_layout/sessions/session-feedbacks/$feedbackId': typeof LayoutSessionsSessionFeedbacksFeedbackIdRoute
  '/_layout/teachers/$teacherId/feedbacks': typeof LayoutTeachersTeacherIdFeedbacksRoute
  '/_layout/teachers/$teacherId/review-notes': typeof LayoutTeachersTeacherIdReviewNotesRoute
  '/_layout/teachers/$teacherId/schedule': typeof LayoutTeachersTeacherIdScheduleRoute
  '/_layout/teachers/$teacherId/weekly-teaching-hours': typeof LayoutTeachersTeacherIdWeeklyTeachingHoursRoute
  '/_layout/books/part/': typeof LayoutBooksPartIndexRoute
  '/_layout/lessons/assessment-contents/': typeof LayoutLessonsAssessmentContentsIndexRoute
  '/_layout/lessons/assessments/': typeof LayoutLessonsAssessmentsIndexRoute
  '/_layout/lessons/learning-paths/': typeof LayoutLessonsLearningPathsIndexRoute
  '/_layout/orgs/$orgId/': typeof LayoutOrgsOrgIdIndexRoute
  '/_layout/orgs/schools/': typeof LayoutOrgsSchoolsIndexRoute
  '/_layout/scheduling/schedules/': typeof LayoutSchedulingSchedulesIndexRoute
  '/_layout/sessions/future/': typeof LayoutSessionsFutureIndexRoute
  '/_layout/sessions/overlapping/': typeof LayoutSessionsOverlappingIndexRoute
  '/_layout/sessions/past/': typeof LayoutSessionsPastIndexRoute
  '/_layout/sessions/session-feedbacks/': typeof LayoutSessionsSessionFeedbacksIndexRoute
  '/_layout/sessions/sub-sessions/': typeof LayoutSessionsSubSessionsIndexRoute
  '/_layout/student-groups/pending-reassignment/': typeof LayoutStudentGroupsPendingReassignmentIndexRoute
  '/_layout/students/$studentId/': typeof LayoutStudentsStudentIdIndexRoute
  '/_layout/students/dropped/': typeof LayoutStudentsDroppedIndexRoute
  '/_layout/students/gla/': typeof LayoutStudentsGlaIndexRoute
  '/_layout/students/learning-issue/': typeof LayoutStudentsLearningIssueIndexRoute
  '/_layout/students/makeup-diagnostic/': typeof LayoutStudentsMakeupDiagnosticIndexRoute
  '/_layout/students/multiple-schedule/': typeof LayoutStudentsMultipleScheduleIndexRoute
  '/_layout/students/no-future-sessions/': typeof LayoutStudentsNoFutureSessionsIndexRoute
  '/_layout/teachers/$teacherId/': typeof LayoutTeachersTeacherIdIndexRoute
  '/_layout/teachers/announcement/': typeof LayoutTeachersAnnouncementIndexRoute
  '/_layout/teachers/attendance/': typeof LayoutTeachersAttendanceIndexRoute
  '/_layout/teachers/availabilities/': typeof LayoutTeachersAvailabilitiesIndexRoute
  '/_layout/teachers/availability-overview/': typeof LayoutTeachersAvailabilityOverviewIndexRoute
  '/_layout/teachers/google-meet-tq-review/': typeof LayoutTeachersGoogleMeetTqReviewIndexRoute
  '/_layout/teachers/missing-google-meet/': typeof LayoutTeachersMissingGoogleMeetIndexRoute
  '/_layout/teachers/missing-zoom-license/': typeof LayoutTeachersMissingZoomLicenseIndexRoute
  '/_layout/teachers/onboarding/': typeof LayoutTeachersOnboardingIndexRoute
  '/_layout/teachers/teacher-pay/': typeof LayoutTeachersTeacherPayIndexRoute
  '/_layout/teachers/tq-review/': typeof LayoutTeachersTqReviewIndexRoute
  '/_layout/orgs/schools/$schoolId/schedules': typeof LayoutOrgsSchoolsSchoolIdSchedulesRoute
  '/_layout/orgs/schools/$schoolId/session-attendance': typeof LayoutOrgsSchoolsSchoolIdSessionAttendanceRoute
  '/_layout/orgs/schools/$schoolId/sessions': typeof LayoutOrgsSchoolsSchoolIdSessionsRoute
  '/_layout/orgs/schools/$schoolId/settings': typeof LayoutOrgsSchoolsSchoolIdSettingsRoute
  '/_layout/orgs/schools/$schoolId/students': typeof LayoutOrgsSchoolsSchoolIdStudentsRoute
  '/_layout/orgs/schools/$schoolId/': typeof LayoutOrgsSchoolsSchoolIdIndexRoute
  '/_layout/orgs/schools/reports/': typeof LayoutOrgsSchoolsReportsIndexRoute
  '/_layout/payments/teaching/$payCycleId/': typeof LayoutPaymentsTeachingPayCycleIdIndexRoute
  '/_layout/students/$studentId/future-sessions/': typeof LayoutStudentsStudentIdFutureSessionsIndexRoute
  '/_layout/students/$studentId/past-student-feedbacks/': typeof LayoutStudentsStudentIdPastStudentFeedbacksIndexRoute
  '/_layout/teachers/$teacherId/future-sessions/': typeof LayoutTeachersTeacherIdFutureSessionsIndexRoute
  '/_layout/teachers/$teacherId/past-sessions/': typeof LayoutTeachersTeacherIdPastSessionsIndexRoute
  '/_layout/teachers/$teacherId/payments/': typeof LayoutTeachersTeacherIdPaymentsIndexRoute
  '/_layout/orgs/schools/$schoolId/classes/$classId': typeof LayoutOrgsSchoolsSchoolIdClassesClassIdRoute
  '/_layout/orgs/schools/$schoolId/one-time-classes/$classId': typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRoute
  '/_layout/orgs/schools/$schoolId/classes/': typeof LayoutOrgsSchoolsSchoolIdClassesIndexRoute
  '/_layout/orgs/schools/$schoolId/one-time-classes/': typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRoute
  '/_layout/teachers/$teacherId/payments/teaching/$payCycleId/': typeof LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/403'
    | '/404'
    | '/my-classes'
    | '/lessons/$lessonId'
    | '/my-classes/calendar'
    | '/my-classes/past'
    | '/my-classes/upcoming'
    | '/payments/guideline'
    | '/sessions/$sessionId'
    | '/teachers-feedback/$feedbackId'
    | '/users/$userId'
    | '/account/'
    | '/books/'
    | '/getting-ready-to-teach/'
    | '/handbook/'
    | '/handouts-and-feedback/'
    | '/lessons/'
    | '/my-availability/'
    | '/my-classes/'
    | '/my-student-groups/'
    | '/orgs/'
    | '/payments/'
    | '/profile/'
    | '/scheduling/'
    | '/school-students/'
    | '/sessions/'
    | '/student-groups/'
    | '/students/'
    | '/teachers-feedback/'
    | '/teachers/'
    | '/users/'
    | '/books/part/$partId'
    | '/lessons/assessment-contents/$assessmentContentId'
    | '/orgs/$orgId/settings'
    | '/sessions/session-feedbacks/$feedbackId'
    | '/teachers/$teacherId/feedbacks'
    | '/teachers/$teacherId/review-notes'
    | '/teachers/$teacherId/schedule'
    | '/teachers/$teacherId/weekly-teaching-hours'
    | '/books/part/'
    | '/lessons/assessment-contents/'
    | '/lessons/assessments/'
    | '/lessons/learning-paths/'
    | '/orgs/$orgId/'
    | '/orgs/schools/'
    | '/scheduling/schedules/'
    | '/sessions/future/'
    | '/sessions/overlapping/'
    | '/sessions/past/'
    | '/sessions/session-feedbacks/'
    | '/sessions/sub-sessions/'
    | '/student-groups/pending-reassignment/'
    | '/students/$studentId/'
    | '/students/dropped/'
    | '/students/gla/'
    | '/students/learning-issue/'
    | '/students/makeup-diagnostic/'
    | '/students/multiple-schedule/'
    | '/students/no-future-sessions/'
    | '/teachers/$teacherId/'
    | '/teachers/announcement/'
    | '/teachers/attendance/'
    | '/teachers/availabilities/'
    | '/teachers/availability-overview/'
    | '/teachers/google-meet-tq-review/'
    | '/teachers/missing-google-meet/'
    | '/teachers/missing-zoom-license/'
    | '/teachers/onboarding/'
    | '/teachers/teacher-pay/'
    | '/teachers/tq-review/'
    | '/orgs/schools/$schoolId/schedules'
    | '/orgs/schools/$schoolId/session-attendance'
    | '/orgs/schools/$schoolId/sessions'
    | '/orgs/schools/$schoolId/settings'
    | '/orgs/schools/$schoolId/students'
    | '/orgs/schools/$schoolId/'
    | '/orgs/schools/reports/'
    | '/payments/teaching/$payCycleId/'
    | '/students/$studentId/future-sessions/'
    | '/students/$studentId/past-student-feedbacks/'
    | '/teachers/$teacherId/future-sessions/'
    | '/teachers/$teacherId/past-sessions/'
    | '/teachers/$teacherId/payments/'
    | '/orgs/schools/$schoolId/classes/$classId'
    | '/orgs/schools/$schoolId/one-time-classes/$classId'
    | '/orgs/schools/$schoolId/classes/'
    | '/orgs/schools/$schoolId/one-time-classes/'
    | '/teachers/$teacherId/payments/teaching/$payCycleId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/403'
    | '/404'
    | '/'
    | '/lessons/$lessonId'
    | '/my-classes/calendar'
    | '/my-classes/past'
    | '/my-classes/upcoming'
    | '/payments/guideline'
    | '/sessions/$sessionId'
    | '/teachers-feedback/$feedbackId'
    | '/users/$userId'
    | '/account'
    | '/books'
    | '/getting-ready-to-teach'
    | '/handbook'
    | '/handouts-and-feedback'
    | '/lessons'
    | '/my-availability'
    | '/my-classes'
    | '/my-student-groups'
    | '/orgs'
    | '/payments'
    | '/profile'
    | '/scheduling'
    | '/school-students'
    | '/sessions'
    | '/student-groups'
    | '/students'
    | '/teachers-feedback'
    | '/teachers'
    | '/users'
    | '/books/part/$partId'
    | '/lessons/assessment-contents/$assessmentContentId'
    | '/orgs/$orgId/settings'
    | '/sessions/session-feedbacks/$feedbackId'
    | '/teachers/$teacherId/feedbacks'
    | '/teachers/$teacherId/review-notes'
    | '/teachers/$teacherId/schedule'
    | '/teachers/$teacherId/weekly-teaching-hours'
    | '/books/part'
    | '/lessons/assessment-contents'
    | '/lessons/assessments'
    | '/lessons/learning-paths'
    | '/orgs/$orgId'
    | '/orgs/schools'
    | '/scheduling/schedules'
    | '/sessions/future'
    | '/sessions/overlapping'
    | '/sessions/past'
    | '/sessions/session-feedbacks'
    | '/sessions/sub-sessions'
    | '/student-groups/pending-reassignment'
    | '/students/$studentId'
    | '/students/dropped'
    | '/students/gla'
    | '/students/learning-issue'
    | '/students/makeup-diagnostic'
    | '/students/multiple-schedule'
    | '/students/no-future-sessions'
    | '/teachers/$teacherId'
    | '/teachers/announcement'
    | '/teachers/attendance'
    | '/teachers/availabilities'
    | '/teachers/availability-overview'
    | '/teachers/google-meet-tq-review'
    | '/teachers/missing-google-meet'
    | '/teachers/missing-zoom-license'
    | '/teachers/onboarding'
    | '/teachers/teacher-pay'
    | '/teachers/tq-review'
    | '/orgs/schools/$schoolId/schedules'
    | '/orgs/schools/$schoolId/session-attendance'
    | '/orgs/schools/$schoolId/sessions'
    | '/orgs/schools/$schoolId/settings'
    | '/orgs/schools/$schoolId/students'
    | '/orgs/schools/$schoolId'
    | '/orgs/schools/reports'
    | '/payments/teaching/$payCycleId'
    | '/students/$studentId/future-sessions'
    | '/students/$studentId/past-student-feedbacks'
    | '/teachers/$teacherId/future-sessions'
    | '/teachers/$teacherId/past-sessions'
    | '/teachers/$teacherId/payments'
    | '/orgs/schools/$schoolId/classes/$classId'
    | '/orgs/schools/$schoolId/one-time-classes/$classId'
    | '/orgs/schools/$schoolId/classes'
    | '/orgs/schools/$schoolId/one-time-classes'
    | '/teachers/$teacherId/payments/teaching/$payCycleId'
  id:
    | '__root__'
    | '/_layout'
    | '/login'
    | '/_layout/403'
    | '/_layout/404'
    | '/_layout/my-classes'
    | '/_layout/'
    | '/_layout/lessons/$lessonId'
    | '/_layout/my-classes/calendar'
    | '/_layout/my-classes/past'
    | '/_layout/my-classes/upcoming'
    | '/_layout/payments/guideline'
    | '/_layout/sessions/$sessionId'
    | '/_layout/teachers-feedback/$feedbackId'
    | '/_layout/users/$userId'
    | '/_layout/account/'
    | '/_layout/books/'
    | '/_layout/getting-ready-to-teach/'
    | '/_layout/handbook/'
    | '/_layout/handouts-and-feedback/'
    | '/_layout/lessons/'
    | '/_layout/my-availability/'
    | '/_layout/my-classes/'
    | '/_layout/my-student-groups/'
    | '/_layout/orgs/'
    | '/_layout/payments/'
    | '/_layout/profile/'
    | '/_layout/scheduling/'
    | '/_layout/school-students/'
    | '/_layout/sessions/'
    | '/_layout/student-groups/'
    | '/_layout/students/'
    | '/_layout/teachers-feedback/'
    | '/_layout/teachers/'
    | '/_layout/users/'
    | '/_layout/books/part/$partId'
    | '/_layout/lessons/assessment-contents/$assessmentContentId'
    | '/_layout/orgs/$orgId/settings'
    | '/_layout/sessions/session-feedbacks/$feedbackId'
    | '/_layout/teachers/$teacherId/feedbacks'
    | '/_layout/teachers/$teacherId/review-notes'
    | '/_layout/teachers/$teacherId/schedule'
    | '/_layout/teachers/$teacherId/weekly-teaching-hours'
    | '/_layout/books/part/'
    | '/_layout/lessons/assessment-contents/'
    | '/_layout/lessons/assessments/'
    | '/_layout/lessons/learning-paths/'
    | '/_layout/orgs/$orgId/'
    | '/_layout/orgs/schools/'
    | '/_layout/scheduling/schedules/'
    | '/_layout/sessions/future/'
    | '/_layout/sessions/overlapping/'
    | '/_layout/sessions/past/'
    | '/_layout/sessions/session-feedbacks/'
    | '/_layout/sessions/sub-sessions/'
    | '/_layout/student-groups/pending-reassignment/'
    | '/_layout/students/$studentId/'
    | '/_layout/students/dropped/'
    | '/_layout/students/gla/'
    | '/_layout/students/learning-issue/'
    | '/_layout/students/makeup-diagnostic/'
    | '/_layout/students/multiple-schedule/'
    | '/_layout/students/no-future-sessions/'
    | '/_layout/teachers/$teacherId/'
    | '/_layout/teachers/announcement/'
    | '/_layout/teachers/attendance/'
    | '/_layout/teachers/availabilities/'
    | '/_layout/teachers/availability-overview/'
    | '/_layout/teachers/google-meet-tq-review/'
    | '/_layout/teachers/missing-google-meet/'
    | '/_layout/teachers/missing-zoom-license/'
    | '/_layout/teachers/onboarding/'
    | '/_layout/teachers/teacher-pay/'
    | '/_layout/teachers/tq-review/'
    | '/_layout/orgs/schools/$schoolId/schedules'
    | '/_layout/orgs/schools/$schoolId/session-attendance'
    | '/_layout/orgs/schools/$schoolId/sessions'
    | '/_layout/orgs/schools/$schoolId/settings'
    | '/_layout/orgs/schools/$schoolId/students'
    | '/_layout/orgs/schools/$schoolId/'
    | '/_layout/orgs/schools/reports/'
    | '/_layout/payments/teaching/$payCycleId/'
    | '/_layout/students/$studentId/future-sessions/'
    | '/_layout/students/$studentId/past-student-feedbacks/'
    | '/_layout/teachers/$teacherId/future-sessions/'
    | '/_layout/teachers/$teacherId/past-sessions/'
    | '/_layout/teachers/$teacherId/payments/'
    | '/_layout/orgs/schools/$schoolId/classes/$classId'
    | '/_layout/orgs/schools/$schoolId/one-time-classes/$classId'
    | '/_layout/orgs/schools/$schoolId/classes/'
    | '/_layout/orgs/schools/$schoolId/one-time-classes/'
    | '/_layout/teachers/$teacherId/payments/teaching/$payCycleId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/my-classes': {
      id: '/_layout/my-classes'
      path: '/my-classes'
      fullPath: '/my-classes'
      preLoaderRoute: typeof LayoutMyClassesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/404': {
      id: '/_layout/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof Layout404RouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/403': {
      id: '/_layout/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof Layout403RouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/users/': {
      id: '/_layout/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof LayoutUsersIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/': {
      id: '/_layout/teachers/'
      path: '/teachers'
      fullPath: '/teachers/'
      preLoaderRoute: typeof LayoutTeachersIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers-feedback/': {
      id: '/_layout/teachers-feedback/'
      path: '/teachers-feedback'
      fullPath: '/teachers-feedback/'
      preLoaderRoute: typeof LayoutTeachersFeedbackIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students/': {
      id: '/_layout/students/'
      path: '/students'
      fullPath: '/students/'
      preLoaderRoute: typeof LayoutStudentsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/student-groups/': {
      id: '/_layout/student-groups/'
      path: '/student-groups'
      fullPath: '/student-groups/'
      preLoaderRoute: typeof LayoutStudentGroupsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/sessions/': {
      id: '/_layout/sessions/'
      path: '/sessions'
      fullPath: '/sessions/'
      preLoaderRoute: typeof LayoutSessionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/school-students/': {
      id: '/_layout/school-students/'
      path: '/school-students'
      fullPath: '/school-students/'
      preLoaderRoute: typeof LayoutSchoolStudentsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/scheduling/': {
      id: '/_layout/scheduling/'
      path: '/scheduling'
      fullPath: '/scheduling/'
      preLoaderRoute: typeof LayoutSchedulingIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/profile/': {
      id: '/_layout/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof LayoutProfileIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/payments/': {
      id: '/_layout/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof LayoutPaymentsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/': {
      id: '/_layout/orgs/'
      path: '/orgs'
      fullPath: '/orgs/'
      preLoaderRoute: typeof LayoutOrgsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/my-student-groups/': {
      id: '/_layout/my-student-groups/'
      path: '/my-student-groups'
      fullPath: '/my-student-groups/'
      preLoaderRoute: typeof LayoutMyStudentGroupsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/my-classes/': {
      id: '/_layout/my-classes/'
      path: '/'
      fullPath: '/my-classes/'
      preLoaderRoute: typeof LayoutMyClassesIndexRouteImport
      parentRoute: typeof LayoutMyClassesRoute
    }
    '/_layout/my-availability/': {
      id: '/_layout/my-availability/'
      path: '/my-availability'
      fullPath: '/my-availability/'
      preLoaderRoute: typeof LayoutMyAvailabilityIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/lessons/': {
      id: '/_layout/lessons/'
      path: '/lessons'
      fullPath: '/lessons/'
      preLoaderRoute: typeof LayoutLessonsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/handouts-and-feedback/': {
      id: '/_layout/handouts-and-feedback/'
      path: '/handouts-and-feedback'
      fullPath: '/handouts-and-feedback/'
      preLoaderRoute: typeof LayoutHandoutsAndFeedbackIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/handbook/': {
      id: '/_layout/handbook/'
      path: '/handbook'
      fullPath: '/handbook/'
      preLoaderRoute: typeof LayoutHandbookIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/getting-ready-to-teach/': {
      id: '/_layout/getting-ready-to-teach/'
      path: '/getting-ready-to-teach'
      fullPath: '/getting-ready-to-teach/'
      preLoaderRoute: typeof LayoutGettingReadyToTeachIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/books/': {
      id: '/_layout/books/'
      path: '/books'
      fullPath: '/books/'
      preLoaderRoute: typeof LayoutBooksIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/account/': {
      id: '/_layout/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof LayoutAccountIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/users/$userId': {
      id: '/_layout/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof LayoutUsersUserIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers-feedback/$feedbackId': {
      id: '/_layout/teachers-feedback/$feedbackId'
      path: '/teachers-feedback/$feedbackId'
      fullPath: '/teachers-feedback/$feedbackId'
      preLoaderRoute: typeof LayoutTeachersFeedbackFeedbackIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/sessions/$sessionId': {
      id: '/_layout/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof LayoutSessionsSessionIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/payments/guideline': {
      id: '/_layout/payments/guideline'
      path: '/payments/guideline'
      fullPath: '/payments/guideline'
      preLoaderRoute: typeof LayoutPaymentsGuidelineRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/my-classes/upcoming': {
      id: '/_layout/my-classes/upcoming'
      path: '/upcoming'
      fullPath: '/my-classes/upcoming'
      preLoaderRoute: typeof LayoutMyClassesUpcomingRouteImport
      parentRoute: typeof LayoutMyClassesRoute
    }
    '/_layout/my-classes/past': {
      id: '/_layout/my-classes/past'
      path: '/past'
      fullPath: '/my-classes/past'
      preLoaderRoute: typeof LayoutMyClassesPastRouteImport
      parentRoute: typeof LayoutMyClassesRoute
    }
    '/_layout/my-classes/calendar': {
      id: '/_layout/my-classes/calendar'
      path: '/calendar'
      fullPath: '/my-classes/calendar'
      preLoaderRoute: typeof LayoutMyClassesCalendarRouteImport
      parentRoute: typeof LayoutMyClassesRoute
    }
    '/_layout/lessons/$lessonId': {
      id: '/_layout/lessons/$lessonId'
      path: '/lessons/$lessonId'
      fullPath: '/lessons/$lessonId'
      preLoaderRoute: typeof LayoutLessonsLessonIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/tq-review/': {
      id: '/_layout/teachers/tq-review/'
      path: '/teachers/tq-review'
      fullPath: '/teachers/tq-review/'
      preLoaderRoute: typeof LayoutTeachersTqReviewIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/teacher-pay/': {
      id: '/_layout/teachers/teacher-pay/'
      path: '/teachers/teacher-pay'
      fullPath: '/teachers/teacher-pay/'
      preLoaderRoute: typeof LayoutTeachersTeacherPayIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/onboarding/': {
      id: '/_layout/teachers/onboarding/'
      path: '/teachers/onboarding'
      fullPath: '/teachers/onboarding/'
      preLoaderRoute: typeof LayoutTeachersOnboardingIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/missing-zoom-license/': {
      id: '/_layout/teachers/missing-zoom-license/'
      path: '/teachers/missing-zoom-license'
      fullPath: '/teachers/missing-zoom-license/'
      preLoaderRoute: typeof LayoutTeachersMissingZoomLicenseIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/missing-google-meet/': {
      id: '/_layout/teachers/missing-google-meet/'
      path: '/teachers/missing-google-meet'
      fullPath: '/teachers/missing-google-meet/'
      preLoaderRoute: typeof LayoutTeachersMissingGoogleMeetIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/google-meet-tq-review/': {
      id: '/_layout/teachers/google-meet-tq-review/'
      path: '/teachers/google-meet-tq-review'
      fullPath: '/teachers/google-meet-tq-review/'
      preLoaderRoute: typeof LayoutTeachersGoogleMeetTqReviewIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/availability-overview/': {
      id: '/_layout/teachers/availability-overview/'
      path: '/teachers/availability-overview'
      fullPath: '/teachers/availability-overview/'
      preLoaderRoute: typeof LayoutTeachersAvailabilityOverviewIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/availabilities/': {
      id: '/_layout/teachers/availabilities/'
      path: '/teachers/availabilities'
      fullPath: '/teachers/availabilities/'
      preLoaderRoute: typeof LayoutTeachersAvailabilitiesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/attendance/': {
      id: '/_layout/teachers/attendance/'
      path: '/teachers/attendance'
      fullPath: '/teachers/attendance/'
      preLoaderRoute: typeof LayoutTeachersAttendanceIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/announcement/': {
      id: '/_layout/teachers/announcement/'
      path: '/teachers/announcement'
      fullPath: '/teachers/announcement/'
      preLoaderRoute: typeof LayoutTeachersAnnouncementIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/$teacherId/': {
      id: '/_layout/teachers/$teacherId/'
      path: '/teachers/$teacherId'
      fullPath: '/teachers/$teacherId/'
      preLoaderRoute: typeof LayoutTeachersTeacherIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students/no-future-sessions/': {
      id: '/_layout/students/no-future-sessions/'
      path: '/students/no-future-sessions'
      fullPath: '/students/no-future-sessions/'
      preLoaderRoute: typeof LayoutStudentsNoFutureSessionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students/multiple-schedule/': {
      id: '/_layout/students/multiple-schedule/'
      path: '/students/multiple-schedule'
      fullPath: '/students/multiple-schedule/'
      preLoaderRoute: typeof LayoutStudentsMultipleScheduleIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students/makeup-diagnostic/': {
      id: '/_layout/students/makeup-diagnostic/'
      path: '/students/makeup-diagnostic'
      fullPath: '/students/makeup-diagnostic/'
      preLoaderRoute: typeof LayoutStudentsMakeupDiagnosticIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students/learning-issue/': {
      id: '/_layout/students/learning-issue/'
      path: '/students/learning-issue'
      fullPath: '/students/learning-issue/'
      preLoaderRoute: typeof LayoutStudentsLearningIssueIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students/gla/': {
      id: '/_layout/students/gla/'
      path: '/students/gla'
      fullPath: '/students/gla/'
      preLoaderRoute: typeof LayoutStudentsGlaIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students/dropped/': {
      id: '/_layout/students/dropped/'
      path: '/students/dropped'
      fullPath: '/students/dropped/'
      preLoaderRoute: typeof LayoutStudentsDroppedIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students/$studentId/': {
      id: '/_layout/students/$studentId/'
      path: '/students/$studentId'
      fullPath: '/students/$studentId/'
      preLoaderRoute: typeof LayoutStudentsStudentIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/student-groups/pending-reassignment/': {
      id: '/_layout/student-groups/pending-reassignment/'
      path: '/student-groups/pending-reassignment'
      fullPath: '/student-groups/pending-reassignment/'
      preLoaderRoute: typeof LayoutStudentGroupsPendingReassignmentIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/sessions/sub-sessions/': {
      id: '/_layout/sessions/sub-sessions/'
      path: '/sessions/sub-sessions'
      fullPath: '/sessions/sub-sessions/'
      preLoaderRoute: typeof LayoutSessionsSubSessionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/sessions/session-feedbacks/': {
      id: '/_layout/sessions/session-feedbacks/'
      path: '/sessions/session-feedbacks'
      fullPath: '/sessions/session-feedbacks/'
      preLoaderRoute: typeof LayoutSessionsSessionFeedbacksIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/sessions/past/': {
      id: '/_layout/sessions/past/'
      path: '/sessions/past'
      fullPath: '/sessions/past/'
      preLoaderRoute: typeof LayoutSessionsPastIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/sessions/overlapping/': {
      id: '/_layout/sessions/overlapping/'
      path: '/sessions/overlapping'
      fullPath: '/sessions/overlapping/'
      preLoaderRoute: typeof LayoutSessionsOverlappingIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/sessions/future/': {
      id: '/_layout/sessions/future/'
      path: '/sessions/future'
      fullPath: '/sessions/future/'
      preLoaderRoute: typeof LayoutSessionsFutureIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/scheduling/schedules/': {
      id: '/_layout/scheduling/schedules/'
      path: '/scheduling/schedules'
      fullPath: '/scheduling/schedules/'
      preLoaderRoute: typeof LayoutSchedulingSchedulesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/': {
      id: '/_layout/orgs/schools/'
      path: '/orgs/schools'
      fullPath: '/orgs/schools/'
      preLoaderRoute: typeof LayoutOrgsSchoolsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/$orgId/': {
      id: '/_layout/orgs/$orgId/'
      path: '/orgs/$orgId'
      fullPath: '/orgs/$orgId/'
      preLoaderRoute: typeof LayoutOrgsOrgIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/lessons/learning-paths/': {
      id: '/_layout/lessons/learning-paths/'
      path: '/lessons/learning-paths'
      fullPath: '/lessons/learning-paths/'
      preLoaderRoute: typeof LayoutLessonsLearningPathsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/lessons/assessments/': {
      id: '/_layout/lessons/assessments/'
      path: '/lessons/assessments'
      fullPath: '/lessons/assessments/'
      preLoaderRoute: typeof LayoutLessonsAssessmentsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/lessons/assessment-contents/': {
      id: '/_layout/lessons/assessment-contents/'
      path: '/lessons/assessment-contents'
      fullPath: '/lessons/assessment-contents/'
      preLoaderRoute: typeof LayoutLessonsAssessmentContentsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/books/part/': {
      id: '/_layout/books/part/'
      path: '/books/part'
      fullPath: '/books/part/'
      preLoaderRoute: typeof LayoutBooksPartIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/$teacherId/weekly-teaching-hours': {
      id: '/_layout/teachers/$teacherId/weekly-teaching-hours'
      path: '/teachers/$teacherId/weekly-teaching-hours'
      fullPath: '/teachers/$teacherId/weekly-teaching-hours'
      preLoaderRoute: typeof LayoutTeachersTeacherIdWeeklyTeachingHoursRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/$teacherId/schedule': {
      id: '/_layout/teachers/$teacherId/schedule'
      path: '/teachers/$teacherId/schedule'
      fullPath: '/teachers/$teacherId/schedule'
      preLoaderRoute: typeof LayoutTeachersTeacherIdScheduleRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/$teacherId/review-notes': {
      id: '/_layout/teachers/$teacherId/review-notes'
      path: '/teachers/$teacherId/review-notes'
      fullPath: '/teachers/$teacherId/review-notes'
      preLoaderRoute: typeof LayoutTeachersTeacherIdReviewNotesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/$teacherId/feedbacks': {
      id: '/_layout/teachers/$teacherId/feedbacks'
      path: '/teachers/$teacherId/feedbacks'
      fullPath: '/teachers/$teacherId/feedbacks'
      preLoaderRoute: typeof LayoutTeachersTeacherIdFeedbacksRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/sessions/session-feedbacks/$feedbackId': {
      id: '/_layout/sessions/session-feedbacks/$feedbackId'
      path: '/sessions/session-feedbacks/$feedbackId'
      fullPath: '/sessions/session-feedbacks/$feedbackId'
      preLoaderRoute: typeof LayoutSessionsSessionFeedbacksFeedbackIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/$orgId/settings': {
      id: '/_layout/orgs/$orgId/settings'
      path: '/orgs/$orgId/settings'
      fullPath: '/orgs/$orgId/settings'
      preLoaderRoute: typeof LayoutOrgsOrgIdSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/lessons/assessment-contents/$assessmentContentId': {
      id: '/_layout/lessons/assessment-contents/$assessmentContentId'
      path: '/lessons/assessment-contents/$assessmentContentId'
      fullPath: '/lessons/assessment-contents/$assessmentContentId'
      preLoaderRoute: typeof LayoutLessonsAssessmentContentsAssessmentContentIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/books/part/$partId': {
      id: '/_layout/books/part/$partId'
      path: '/books/part/$partId'
      fullPath: '/books/part/$partId'
      preLoaderRoute: typeof LayoutBooksPartPartIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/$teacherId/payments/': {
      id: '/_layout/teachers/$teacherId/payments/'
      path: '/teachers/$teacherId/payments'
      fullPath: '/teachers/$teacherId/payments/'
      preLoaderRoute: typeof LayoutTeachersTeacherIdPaymentsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/$teacherId/past-sessions/': {
      id: '/_layout/teachers/$teacherId/past-sessions/'
      path: '/teachers/$teacherId/past-sessions'
      fullPath: '/teachers/$teacherId/past-sessions/'
      preLoaderRoute: typeof LayoutTeachersTeacherIdPastSessionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/$teacherId/future-sessions/': {
      id: '/_layout/teachers/$teacherId/future-sessions/'
      path: '/teachers/$teacherId/future-sessions'
      fullPath: '/teachers/$teacherId/future-sessions/'
      preLoaderRoute: typeof LayoutTeachersTeacherIdFutureSessionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students/$studentId/past-student-feedbacks/': {
      id: '/_layout/students/$studentId/past-student-feedbacks/'
      path: '/students/$studentId/past-student-feedbacks'
      fullPath: '/students/$studentId/past-student-feedbacks/'
      preLoaderRoute: typeof LayoutStudentsStudentIdPastStudentFeedbacksIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/students/$studentId/future-sessions/': {
      id: '/_layout/students/$studentId/future-sessions/'
      path: '/students/$studentId/future-sessions'
      fullPath: '/students/$studentId/future-sessions/'
      preLoaderRoute: typeof LayoutStudentsStudentIdFutureSessionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/payments/teaching/$payCycleId/': {
      id: '/_layout/payments/teaching/$payCycleId/'
      path: '/payments/teaching/$payCycleId'
      fullPath: '/payments/teaching/$payCycleId/'
      preLoaderRoute: typeof LayoutPaymentsTeachingPayCycleIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/reports/': {
      id: '/_layout/orgs/schools/reports/'
      path: '/orgs/schools/reports'
      fullPath: '/orgs/schools/reports/'
      preLoaderRoute: typeof LayoutOrgsSchoolsReportsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/$schoolId/': {
      id: '/_layout/orgs/schools/$schoolId/'
      path: '/orgs/schools/$schoolId'
      fullPath: '/orgs/schools/$schoolId/'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/$schoolId/students': {
      id: '/_layout/orgs/schools/$schoolId/students'
      path: '/orgs/schools/$schoolId/students'
      fullPath: '/orgs/schools/$schoolId/students'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdStudentsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/$schoolId/settings': {
      id: '/_layout/orgs/schools/$schoolId/settings'
      path: '/orgs/schools/$schoolId/settings'
      fullPath: '/orgs/schools/$schoolId/settings'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/$schoolId/sessions': {
      id: '/_layout/orgs/schools/$schoolId/sessions'
      path: '/orgs/schools/$schoolId/sessions'
      fullPath: '/orgs/schools/$schoolId/sessions'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdSessionsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/$schoolId/session-attendance': {
      id: '/_layout/orgs/schools/$schoolId/session-attendance'
      path: '/orgs/schools/$schoolId/session-attendance'
      fullPath: '/orgs/schools/$schoolId/session-attendance'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdSessionAttendanceRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/$schoolId/schedules': {
      id: '/_layout/orgs/schools/$schoolId/schedules'
      path: '/orgs/schools/$schoolId/schedules'
      fullPath: '/orgs/schools/$schoolId/schedules'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdSchedulesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/$schoolId/one-time-classes/': {
      id: '/_layout/orgs/schools/$schoolId/one-time-classes/'
      path: '/orgs/schools/$schoolId/one-time-classes'
      fullPath: '/orgs/schools/$schoolId/one-time-classes/'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/$schoolId/classes/': {
      id: '/_layout/orgs/schools/$schoolId/classes/'
      path: '/orgs/schools/$schoolId/classes'
      fullPath: '/orgs/schools/$schoolId/classes/'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdClassesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/$schoolId/one-time-classes/$classId': {
      id: '/_layout/orgs/schools/$schoolId/one-time-classes/$classId'
      path: '/orgs/schools/$schoolId/one-time-classes/$classId'
      fullPath: '/orgs/schools/$schoolId/one-time-classes/$classId'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/orgs/schools/$schoolId/classes/$classId': {
      id: '/_layout/orgs/schools/$schoolId/classes/$classId'
      path: '/orgs/schools/$schoolId/classes/$classId'
      fullPath: '/orgs/schools/$schoolId/classes/$classId'
      preLoaderRoute: typeof LayoutOrgsSchoolsSchoolIdClassesClassIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/teachers/$teacherId/payments/teaching/$payCycleId/': {
      id: '/_layout/teachers/$teacherId/payments/teaching/$payCycleId/'
      path: '/teachers/$teacherId/payments/teaching/$payCycleId'
      fullPath: '/teachers/$teacherId/payments/teaching/$payCycleId/'
      preLoaderRoute: typeof LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface LayoutMyClassesRouteChildren {
  LayoutMyClassesCalendarRoute: typeof LayoutMyClassesCalendarRoute
  LayoutMyClassesPastRoute: typeof LayoutMyClassesPastRoute
  LayoutMyClassesUpcomingRoute: typeof LayoutMyClassesUpcomingRoute
  LayoutMyClassesIndexRoute: typeof LayoutMyClassesIndexRoute
}

const LayoutMyClassesRouteChildren: LayoutMyClassesRouteChildren = {
  LayoutMyClassesCalendarRoute: LayoutMyClassesCalendarRoute,
  LayoutMyClassesPastRoute: LayoutMyClassesPastRoute,
  LayoutMyClassesUpcomingRoute: LayoutMyClassesUpcomingRoute,
  LayoutMyClassesIndexRoute: LayoutMyClassesIndexRoute,
}

const LayoutMyClassesRouteWithChildren = LayoutMyClassesRoute._addFileChildren(
  LayoutMyClassesRouteChildren,
)

interface LayoutRouteChildren {
  Layout403Route: typeof Layout403Route
  Layout404Route: typeof Layout404Route
  LayoutMyClassesRoute: typeof LayoutMyClassesRouteWithChildren
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutLessonsLessonIdRoute: typeof LayoutLessonsLessonIdRoute
  LayoutPaymentsGuidelineRoute: typeof LayoutPaymentsGuidelineRoute
  LayoutSessionsSessionIdRoute: typeof LayoutSessionsSessionIdRoute
  LayoutTeachersFeedbackFeedbackIdRoute: typeof LayoutTeachersFeedbackFeedbackIdRoute
  LayoutUsersUserIdRoute: typeof LayoutUsersUserIdRoute
  LayoutAccountIndexRoute: typeof LayoutAccountIndexRoute
  LayoutBooksIndexRoute: typeof LayoutBooksIndexRoute
  LayoutGettingReadyToTeachIndexRoute: typeof LayoutGettingReadyToTeachIndexRoute
  LayoutHandbookIndexRoute: typeof LayoutHandbookIndexRoute
  LayoutHandoutsAndFeedbackIndexRoute: typeof LayoutHandoutsAndFeedbackIndexRoute
  LayoutLessonsIndexRoute: typeof LayoutLessonsIndexRoute
  LayoutMyAvailabilityIndexRoute: typeof LayoutMyAvailabilityIndexRoute
  LayoutMyStudentGroupsIndexRoute: typeof LayoutMyStudentGroupsIndexRoute
  LayoutOrgsIndexRoute: typeof LayoutOrgsIndexRoute
  LayoutPaymentsIndexRoute: typeof LayoutPaymentsIndexRoute
  LayoutProfileIndexRoute: typeof LayoutProfileIndexRoute
  LayoutSchedulingIndexRoute: typeof LayoutSchedulingIndexRoute
  LayoutSchoolStudentsIndexRoute: typeof LayoutSchoolStudentsIndexRoute
  LayoutSessionsIndexRoute: typeof LayoutSessionsIndexRoute
  LayoutStudentGroupsIndexRoute: typeof LayoutStudentGroupsIndexRoute
  LayoutStudentsIndexRoute: typeof LayoutStudentsIndexRoute
  LayoutTeachersFeedbackIndexRoute: typeof LayoutTeachersFeedbackIndexRoute
  LayoutTeachersIndexRoute: typeof LayoutTeachersIndexRoute
  LayoutUsersIndexRoute: typeof LayoutUsersIndexRoute
  LayoutBooksPartPartIdRoute: typeof LayoutBooksPartPartIdRoute
  LayoutLessonsAssessmentContentsAssessmentContentIdRoute: typeof LayoutLessonsAssessmentContentsAssessmentContentIdRoute
  LayoutOrgsOrgIdSettingsRoute: typeof LayoutOrgsOrgIdSettingsRoute
  LayoutSessionsSessionFeedbacksFeedbackIdRoute: typeof LayoutSessionsSessionFeedbacksFeedbackIdRoute
  LayoutTeachersTeacherIdFeedbacksRoute: typeof LayoutTeachersTeacherIdFeedbacksRoute
  LayoutTeachersTeacherIdReviewNotesRoute: typeof LayoutTeachersTeacherIdReviewNotesRoute
  LayoutTeachersTeacherIdScheduleRoute: typeof LayoutTeachersTeacherIdScheduleRoute
  LayoutTeachersTeacherIdWeeklyTeachingHoursRoute: typeof LayoutTeachersTeacherIdWeeklyTeachingHoursRoute
  LayoutBooksPartIndexRoute: typeof LayoutBooksPartIndexRoute
  LayoutLessonsAssessmentContentsIndexRoute: typeof LayoutLessonsAssessmentContentsIndexRoute
  LayoutLessonsAssessmentsIndexRoute: typeof LayoutLessonsAssessmentsIndexRoute
  LayoutLessonsLearningPathsIndexRoute: typeof LayoutLessonsLearningPathsIndexRoute
  LayoutOrgsOrgIdIndexRoute: typeof LayoutOrgsOrgIdIndexRoute
  LayoutOrgsSchoolsIndexRoute: typeof LayoutOrgsSchoolsIndexRoute
  LayoutSchedulingSchedulesIndexRoute: typeof LayoutSchedulingSchedulesIndexRoute
  LayoutSessionsFutureIndexRoute: typeof LayoutSessionsFutureIndexRoute
  LayoutSessionsOverlappingIndexRoute: typeof LayoutSessionsOverlappingIndexRoute
  LayoutSessionsPastIndexRoute: typeof LayoutSessionsPastIndexRoute
  LayoutSessionsSessionFeedbacksIndexRoute: typeof LayoutSessionsSessionFeedbacksIndexRoute
  LayoutSessionsSubSessionsIndexRoute: typeof LayoutSessionsSubSessionsIndexRoute
  LayoutStudentGroupsPendingReassignmentIndexRoute: typeof LayoutStudentGroupsPendingReassignmentIndexRoute
  LayoutStudentsStudentIdIndexRoute: typeof LayoutStudentsStudentIdIndexRoute
  LayoutStudentsDroppedIndexRoute: typeof LayoutStudentsDroppedIndexRoute
  LayoutStudentsGlaIndexRoute: typeof LayoutStudentsGlaIndexRoute
  LayoutStudentsLearningIssueIndexRoute: typeof LayoutStudentsLearningIssueIndexRoute
  LayoutStudentsMakeupDiagnosticIndexRoute: typeof LayoutStudentsMakeupDiagnosticIndexRoute
  LayoutStudentsMultipleScheduleIndexRoute: typeof LayoutStudentsMultipleScheduleIndexRoute
  LayoutStudentsNoFutureSessionsIndexRoute: typeof LayoutStudentsNoFutureSessionsIndexRoute
  LayoutTeachersTeacherIdIndexRoute: typeof LayoutTeachersTeacherIdIndexRoute
  LayoutTeachersAnnouncementIndexRoute: typeof LayoutTeachersAnnouncementIndexRoute
  LayoutTeachersAttendanceIndexRoute: typeof LayoutTeachersAttendanceIndexRoute
  LayoutTeachersAvailabilitiesIndexRoute: typeof LayoutTeachersAvailabilitiesIndexRoute
  LayoutTeachersAvailabilityOverviewIndexRoute: typeof LayoutTeachersAvailabilityOverviewIndexRoute
  LayoutTeachersGoogleMeetTqReviewIndexRoute: typeof LayoutTeachersGoogleMeetTqReviewIndexRoute
  LayoutTeachersMissingGoogleMeetIndexRoute: typeof LayoutTeachersMissingGoogleMeetIndexRoute
  LayoutTeachersMissingZoomLicenseIndexRoute: typeof LayoutTeachersMissingZoomLicenseIndexRoute
  LayoutTeachersOnboardingIndexRoute: typeof LayoutTeachersOnboardingIndexRoute
  LayoutTeachersTeacherPayIndexRoute: typeof LayoutTeachersTeacherPayIndexRoute
  LayoutTeachersTqReviewIndexRoute: typeof LayoutTeachersTqReviewIndexRoute
  LayoutOrgsSchoolsSchoolIdSchedulesRoute: typeof LayoutOrgsSchoolsSchoolIdSchedulesRoute
  LayoutOrgsSchoolsSchoolIdSessionAttendanceRoute: typeof LayoutOrgsSchoolsSchoolIdSessionAttendanceRoute
  LayoutOrgsSchoolsSchoolIdSessionsRoute: typeof LayoutOrgsSchoolsSchoolIdSessionsRoute
  LayoutOrgsSchoolsSchoolIdSettingsRoute: typeof LayoutOrgsSchoolsSchoolIdSettingsRoute
  LayoutOrgsSchoolsSchoolIdStudentsRoute: typeof LayoutOrgsSchoolsSchoolIdStudentsRoute
  LayoutOrgsSchoolsSchoolIdIndexRoute: typeof LayoutOrgsSchoolsSchoolIdIndexRoute
  LayoutOrgsSchoolsReportsIndexRoute: typeof LayoutOrgsSchoolsReportsIndexRoute
  LayoutPaymentsTeachingPayCycleIdIndexRoute: typeof LayoutPaymentsTeachingPayCycleIdIndexRoute
  LayoutStudentsStudentIdFutureSessionsIndexRoute: typeof LayoutStudentsStudentIdFutureSessionsIndexRoute
  LayoutStudentsStudentIdPastStudentFeedbacksIndexRoute: typeof LayoutStudentsStudentIdPastStudentFeedbacksIndexRoute
  LayoutTeachersTeacherIdFutureSessionsIndexRoute: typeof LayoutTeachersTeacherIdFutureSessionsIndexRoute
  LayoutTeachersTeacherIdPastSessionsIndexRoute: typeof LayoutTeachersTeacherIdPastSessionsIndexRoute
  LayoutTeachersTeacherIdPaymentsIndexRoute: typeof LayoutTeachersTeacherIdPaymentsIndexRoute
  LayoutOrgsSchoolsSchoolIdClassesClassIdRoute: typeof LayoutOrgsSchoolsSchoolIdClassesClassIdRoute
  LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRoute: typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRoute
  LayoutOrgsSchoolsSchoolIdClassesIndexRoute: typeof LayoutOrgsSchoolsSchoolIdClassesIndexRoute
  LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRoute: typeof LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRoute
  LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRoute: typeof LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  Layout403Route: Layout403Route,
  Layout404Route: Layout404Route,
  LayoutMyClassesRoute: LayoutMyClassesRouteWithChildren,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutLessonsLessonIdRoute: LayoutLessonsLessonIdRoute,
  LayoutPaymentsGuidelineRoute: LayoutPaymentsGuidelineRoute,
  LayoutSessionsSessionIdRoute: LayoutSessionsSessionIdRoute,
  LayoutTeachersFeedbackFeedbackIdRoute: LayoutTeachersFeedbackFeedbackIdRoute,
  LayoutUsersUserIdRoute: LayoutUsersUserIdRoute,
  LayoutAccountIndexRoute: LayoutAccountIndexRoute,
  LayoutBooksIndexRoute: LayoutBooksIndexRoute,
  LayoutGettingReadyToTeachIndexRoute: LayoutGettingReadyToTeachIndexRoute,
  LayoutHandbookIndexRoute: LayoutHandbookIndexRoute,
  LayoutHandoutsAndFeedbackIndexRoute: LayoutHandoutsAndFeedbackIndexRoute,
  LayoutLessonsIndexRoute: LayoutLessonsIndexRoute,
  LayoutMyAvailabilityIndexRoute: LayoutMyAvailabilityIndexRoute,
  LayoutMyStudentGroupsIndexRoute: LayoutMyStudentGroupsIndexRoute,
  LayoutOrgsIndexRoute: LayoutOrgsIndexRoute,
  LayoutPaymentsIndexRoute: LayoutPaymentsIndexRoute,
  LayoutProfileIndexRoute: LayoutProfileIndexRoute,
  LayoutSchedulingIndexRoute: LayoutSchedulingIndexRoute,
  LayoutSchoolStudentsIndexRoute: LayoutSchoolStudentsIndexRoute,
  LayoutSessionsIndexRoute: LayoutSessionsIndexRoute,
  LayoutStudentGroupsIndexRoute: LayoutStudentGroupsIndexRoute,
  LayoutStudentsIndexRoute: LayoutStudentsIndexRoute,
  LayoutTeachersFeedbackIndexRoute: LayoutTeachersFeedbackIndexRoute,
  LayoutTeachersIndexRoute: LayoutTeachersIndexRoute,
  LayoutUsersIndexRoute: LayoutUsersIndexRoute,
  LayoutBooksPartPartIdRoute: LayoutBooksPartPartIdRoute,
  LayoutLessonsAssessmentContentsAssessmentContentIdRoute:
    LayoutLessonsAssessmentContentsAssessmentContentIdRoute,
  LayoutOrgsOrgIdSettingsRoute: LayoutOrgsOrgIdSettingsRoute,
  LayoutSessionsSessionFeedbacksFeedbackIdRoute:
    LayoutSessionsSessionFeedbacksFeedbackIdRoute,
  LayoutTeachersTeacherIdFeedbacksRoute: LayoutTeachersTeacherIdFeedbacksRoute,
  LayoutTeachersTeacherIdReviewNotesRoute:
    LayoutTeachersTeacherIdReviewNotesRoute,
  LayoutTeachersTeacherIdScheduleRoute: LayoutTeachersTeacherIdScheduleRoute,
  LayoutTeachersTeacherIdWeeklyTeachingHoursRoute:
    LayoutTeachersTeacherIdWeeklyTeachingHoursRoute,
  LayoutBooksPartIndexRoute: LayoutBooksPartIndexRoute,
  LayoutLessonsAssessmentContentsIndexRoute:
    LayoutLessonsAssessmentContentsIndexRoute,
  LayoutLessonsAssessmentsIndexRoute: LayoutLessonsAssessmentsIndexRoute,
  LayoutLessonsLearningPathsIndexRoute: LayoutLessonsLearningPathsIndexRoute,
  LayoutOrgsOrgIdIndexRoute: LayoutOrgsOrgIdIndexRoute,
  LayoutOrgsSchoolsIndexRoute: LayoutOrgsSchoolsIndexRoute,
  LayoutSchedulingSchedulesIndexRoute: LayoutSchedulingSchedulesIndexRoute,
  LayoutSessionsFutureIndexRoute: LayoutSessionsFutureIndexRoute,
  LayoutSessionsOverlappingIndexRoute: LayoutSessionsOverlappingIndexRoute,
  LayoutSessionsPastIndexRoute: LayoutSessionsPastIndexRoute,
  LayoutSessionsSessionFeedbacksIndexRoute:
    LayoutSessionsSessionFeedbacksIndexRoute,
  LayoutSessionsSubSessionsIndexRoute: LayoutSessionsSubSessionsIndexRoute,
  LayoutStudentGroupsPendingReassignmentIndexRoute:
    LayoutStudentGroupsPendingReassignmentIndexRoute,
  LayoutStudentsStudentIdIndexRoute: LayoutStudentsStudentIdIndexRoute,
  LayoutStudentsDroppedIndexRoute: LayoutStudentsDroppedIndexRoute,
  LayoutStudentsGlaIndexRoute: LayoutStudentsGlaIndexRoute,
  LayoutStudentsLearningIssueIndexRoute: LayoutStudentsLearningIssueIndexRoute,
  LayoutStudentsMakeupDiagnosticIndexRoute:
    LayoutStudentsMakeupDiagnosticIndexRoute,
  LayoutStudentsMultipleScheduleIndexRoute:
    LayoutStudentsMultipleScheduleIndexRoute,
  LayoutStudentsNoFutureSessionsIndexRoute:
    LayoutStudentsNoFutureSessionsIndexRoute,
  LayoutTeachersTeacherIdIndexRoute: LayoutTeachersTeacherIdIndexRoute,
  LayoutTeachersAnnouncementIndexRoute: LayoutTeachersAnnouncementIndexRoute,
  LayoutTeachersAttendanceIndexRoute: LayoutTeachersAttendanceIndexRoute,
  LayoutTeachersAvailabilitiesIndexRoute:
    LayoutTeachersAvailabilitiesIndexRoute,
  LayoutTeachersAvailabilityOverviewIndexRoute:
    LayoutTeachersAvailabilityOverviewIndexRoute,
  LayoutTeachersGoogleMeetTqReviewIndexRoute:
    LayoutTeachersGoogleMeetTqReviewIndexRoute,
  LayoutTeachersMissingGoogleMeetIndexRoute:
    LayoutTeachersMissingGoogleMeetIndexRoute,
  LayoutTeachersMissingZoomLicenseIndexRoute:
    LayoutTeachersMissingZoomLicenseIndexRoute,
  LayoutTeachersOnboardingIndexRoute: LayoutTeachersOnboardingIndexRoute,
  LayoutTeachersTeacherPayIndexRoute: LayoutTeachersTeacherPayIndexRoute,
  LayoutTeachersTqReviewIndexRoute: LayoutTeachersTqReviewIndexRoute,
  LayoutOrgsSchoolsSchoolIdSchedulesRoute:
    LayoutOrgsSchoolsSchoolIdSchedulesRoute,
  LayoutOrgsSchoolsSchoolIdSessionAttendanceRoute:
    LayoutOrgsSchoolsSchoolIdSessionAttendanceRoute,
  LayoutOrgsSchoolsSchoolIdSessionsRoute:
    LayoutOrgsSchoolsSchoolIdSessionsRoute,
  LayoutOrgsSchoolsSchoolIdSettingsRoute:
    LayoutOrgsSchoolsSchoolIdSettingsRoute,
  LayoutOrgsSchoolsSchoolIdStudentsRoute:
    LayoutOrgsSchoolsSchoolIdStudentsRoute,
  LayoutOrgsSchoolsSchoolIdIndexRoute: LayoutOrgsSchoolsSchoolIdIndexRoute,
  LayoutOrgsSchoolsReportsIndexRoute: LayoutOrgsSchoolsReportsIndexRoute,
  LayoutPaymentsTeachingPayCycleIdIndexRoute:
    LayoutPaymentsTeachingPayCycleIdIndexRoute,
  LayoutStudentsStudentIdFutureSessionsIndexRoute:
    LayoutStudentsStudentIdFutureSessionsIndexRoute,
  LayoutStudentsStudentIdPastStudentFeedbacksIndexRoute:
    LayoutStudentsStudentIdPastStudentFeedbacksIndexRoute,
  LayoutTeachersTeacherIdFutureSessionsIndexRoute:
    LayoutTeachersTeacherIdFutureSessionsIndexRoute,
  LayoutTeachersTeacherIdPastSessionsIndexRoute:
    LayoutTeachersTeacherIdPastSessionsIndexRoute,
  LayoutTeachersTeacherIdPaymentsIndexRoute:
    LayoutTeachersTeacherIdPaymentsIndexRoute,
  LayoutOrgsSchoolsSchoolIdClassesClassIdRoute:
    LayoutOrgsSchoolsSchoolIdClassesClassIdRoute,
  LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRoute:
    LayoutOrgsSchoolsSchoolIdOneTimeClassesClassIdRoute,
  LayoutOrgsSchoolsSchoolIdClassesIndexRoute:
    LayoutOrgsSchoolsSchoolIdClassesIndexRoute,
  LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRoute:
    LayoutOrgsSchoolsSchoolIdOneTimeClassesIndexRoute,
  LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRoute:
    LayoutTeachersTeacherIdPaymentsTeachingPayCycleIdIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
